import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Removes one owner's saved split so they use the default source again
export const resetFundAllocation = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/profit_distribution/resetFundAllocation`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
